import { Suspense } from "react";
import { ExpensesReportsTab } from "../components";

function ExpensesReportsPageContent() {
	return (
		<div className="w-full space-y-6 px-6 py-8">
			<ExpensesReportsTab />
		</div>
	);
}

export default function ExpensesReportsPage() {
	return (
		<Suspense
			fallback={
				<div className="p-6 text-quaternary text-sm">Carregando...</div>
			}
		>
			<ExpensesReportsPageContent />
		</Suspense>
	);
}
